export default __webpack_public_path__ + "static/logo-17fa1f5886ea7da82e6a01082b9ab966.svg";